import { SectionHeading } from "../components/common/SectionHeading";
import { featured } from "../data/projects";
import { ProjectCard } from "../components/projects/ProjectCard";
export function FeaturedWork() {
  return (
    <section
      id="work"
      className="work-section shell"
      aria-labelledby="work-heading"
    >
      <SectionHeading
        id="work-heading"
        eyebrow="01 / SELECTED WORK"
        title={
          <>
            Built for the
            <br />
            <em>way people work.</em>
          </>
        }
        description={
          <>
            Professional products and personal explorations.
            <br />A closer look at my role, process, and implementation.
          </>
        }
        trailing={
          <span className="section-count">
            ({String(featured.length).padStart(2, "0")})
          </span>
        }
      />
      <div className="project-grid">
        {featured.map((project, index) => (
          <ProjectCard key={project.slug} project={project} index={index} />
        ))}
      </div>
    </section>
  );
}
